import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  sessionField: {
    width: 'fit-content',
  },
  empty: {
    alignItems: 'center',
    color: tokens.colorNeutralForeground3,
    padding: tokens.spacingVerticalXXL,
  },
});
